/**
 * @generated SignedSource<<70f2489763b48c178dc63a6af5aa8fb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletependingservicePayload",
    "kind": "LinkedField",
    "name": "deletependingservice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePendingServiceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePendingServiceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea3813e11dc3afcc2746842db0d2886d",
    "id": null,
    "metadata": {},
    "name": "DeletePendingServiceMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePendingServiceMutation(\n  $input: DeletependingserviceInput!\n) {\n  deletependingservice(input: $input) {\n    integer\n  }\n}\n"
  }
};
})();

node.hash = "97e511d6b8ba628f6934da9cee800740";

module.exports = node;
